/**
 * Notches visual system — v0.1
 *
 * Palette extracted from Get Rich the Boring Way (book cover).
 * Approved 2026-07-16.
 *
 * Source of truth: brand/positioning.md + brand/voice.md at repo root.
 * This file is the JS/CSS implementation of the palette + type tokens for
 * the new marketing site under /n2/*. Do not import from anywhere outside
 * frontend/src/n2/ — the intent is total isolation from the existing app
 * until the marketing rebrand ships and root routes swap.
 */

export const palette = {
  // Core — extracted from the cover
  paper:      '#faf7f0',
  paper2:     '#f2ebdc',
  ink:        '#1a1613',
  ink2:       '#4a4038',
  ink3:       '#8a7d70',
  gold:       '#c9a24a',
  goldDeep:   '#8b6f2a',
  goldLight:  '#e8c866',
  line:       '#e8ddc7',

  // Semantic — shifted into the warm palette
  positive:   '#4a7a44',
  caution:    '#b8823a',
  negative:   '#8f3a2e',
} as const;

export const type = {
  // Display: Fraunces is the target (loaded via <link> in N2Frame). Georgia is
  // the fallback and reads well at display sizes on every OS.
  serif: '"Fraunces", Georgia, "Iowan Old Style", "New York", serif',
  sans:  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  mono:  'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
} as const;

export const space = {
  xxs: 4,
  xs:  8,
  sm:  12,
  md:  16,
  lg:  24,
  xl:  32,
  xxl: 48,
  hero: 80,
} as const;

// Emit palette as CSS custom properties so we can also style via className.
// Injected once by N2Frame on mount.
export const cssVariables = `
  --paper:      ${palette.paper};
  --paper-2:    ${palette.paper2};
  --ink:        ${palette.ink};
  --ink-2:      ${palette.ink2};
  --ink-3:      ${palette.ink3};
  --gold:       ${palette.gold};
  --gold-deep:  ${palette.goldDeep};
  --gold-light: ${palette.goldLight};
  --line:       ${palette.line};
  --positive:   ${palette.positive};
  --caution:    ${palette.caution};
  --negative:   ${palette.negative};
  --serif:      ${type.serif};
  --sans:       ${type.sans};
  --mono:       ${type.mono};
`;
